'use strict';

var loadingLabel =  React.createFactory(require('scripts/widgets/loading-label'));

React.render( loadingLabel({ displayMessage: 'This is the message', displayPosition: 'top-left', displayTimeout: 3000 }), document.getElementById('clean') );

